import { CreateMediaCategoryDto } from "~/api/dto/media-category/create-media-category.dto"
import { MediaCategoryDto } from "~/api/dto/media-category/media-category.dto"
import { emptySplitApi as api } from "./emptyApi"

export type MediaCategoryControllerGetMediaCategoriesApiResponse =
  /** status 200  */ MediaCategoryDto[]
export type MediaCategoryControllerGetMediaCategoriesApiResponseArg = void
export type MediaCategoryControllerCreateMediaCategoryApiResponse =
  /** status 200  */ MediaCategoryDto
export type MediaCategoryControllerCreateMediaCategoryApiResponseArg = {
  body: CreateMediaCategoryDto
}
export type MediaCategoryControllerGetMediaCategoryApiResponse =
  /** status 200  */ MediaCategoryDto
export type MediaCategoryControllerGetMediaCategoryApiResponseArg = {
  id: string
}
export type MediaCategoryControllerDeleteMediaCategoriesApiResponse =
  /** status 200  */ void
export type MediaCategoryControllerDeleteMediaCategoriesApiResponseArg = {
  id: string
}

export type MediaCategoryControllerSetMediaCategoryApiResponse =
  /** status 200  */ void
export type MediaCategoryControllerSetMediaCategoryApiResponseArg = {
  type: string
  id: string
  body: { value: string; channel: string }
}
export type MediaCategoryControllerClearMediaCategoryApiResponse =
  /** status 200  */ void
export type MediaCategoryControllerClearMediaCategoryApiResponseArg = {
  type: string
  id: string
}

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    mediaCategoryControllerGetMediaCategories: build.query<
      MediaCategoryControllerGetMediaCategoriesApiResponse,
      MediaCategoryControllerGetMediaCategoriesApiResponseArg
    >({
      query: () => ({ url: `/media-category` }),
    }),
    mediaCategoryControllerPostMediaCategories: build.mutation<
      MediaCategoryControllerCreateMediaCategoryApiResponse,
      MediaCategoryControllerCreateMediaCategoryApiResponseArg
    >({
      query: queryArg => ({
        url: `/media-category`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    mediaCategoryControllerGetMediaCategory: build.query<
      MediaCategoryControllerGetMediaCategoryApiResponse,
      MediaCategoryControllerGetMediaCategoryApiResponseArg
    >({
      query: queryArg => ({
        url: `/media-category/${queryArg.id}`,
      }),
    }),
    mediaCategoryControllerDeleteMediaCategories: build.mutation<
      MediaCategoryControllerDeleteMediaCategoriesApiResponse,
      MediaCategoryControllerDeleteMediaCategoriesApiResponseArg
    >({
      query: queryArg => ({
        url: `/media-category/${queryArg.id}`,
        method: "DELETE",
      }),
    }),

    mediaCategoryControllerSetMediaCategory: build.mutation<
      MediaCategoryControllerSetMediaCategoryApiResponse,
      MediaCategoryControllerSetMediaCategoryApiResponseArg
    >({
      query: queryArg => ({
        url: `/media-category/${queryArg.type}/${queryArg.id}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    mediaCategoryControllerClearMediaCategory: build.mutation<
      MediaCategoryControllerClearMediaCategoryApiResponse,
      MediaCategoryControllerClearMediaCategoryApiResponseArg
    >({
      query: queryArg => ({
        url: `/media-category/${queryArg.type}/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: false,
})

export const {
  useMediaCategoryControllerGetMediaCategoryQuery,
  useMediaCategoryControllerGetMediaCategoriesQuery,
  useMediaCategoryControllerPostMediaCategoriesMutation,
  useMediaCategoryControllerDeleteMediaCategoriesMutation,
  useMediaCategoryControllerSetMediaCategoryMutation,
  useMediaCategoryControllerClearMediaCategoryMutation,
} = injectedRtkApi

export { injectedRtkApi as generatedApi }
